<template>
  <ProjectsOverview />
</template>

<script lang="ts">
import Vue from "vue";
import ProjectsOverview from "@/components/projects/container/ProjectsOverview.vue";

export default Vue.extend({
  components: {
    ProjectsOverview,
  },
});
</script>
